module.exports = __webpack_public_path__ + "static/media/one-stack-nav-active.2884c240.svg";